import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {toAgentId} from '../../../../../types'
import {AgentParametersEntryPoint} from '../../../AgentsPages/AgentPage/AgentParameters/AgentParameters.entryPoint'

import type {AgentPageContainerComponent} from './AgentPipelinePage.container'
import {query} from './AgentPipelinePage.queries'

import {makeResource} from 'src/utils/makeResource'

export const AgentPipelinePageEntryPoint: EntryPoint<
  AgentPageContainerComponent,
  LoaderFunctionArgs
> = {
  root: makeResource(
    'AgentPipelinePage',
    () => import(/* webpackChunkName: "AgentPipelinePage" */ './AgentPipelinePage.container'),
  ),
  getPreloadProps: ({params}) => ({
    queries: {
      main: {
        parameters: getRequest(query),
        variables: {locator: `id:${params.agentId}`},
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
    entryPoints: {
      parameters: {
        entryPoint: AgentParametersEntryPoint,
        entryPointParams: toAgentId(params.agentId!),
      },
    },
  }),
}
